import React from 'react'
import { Outlet, NavLink } from 'react-router-dom'
import MyIcon from '../../components/general/icon'

export default function AlumniNav() {
  const computedClassName = ({ isActive }) => {
    return isActive ?  "secondaryNav-menu secondaryNav-menuActive" : "secondaryNav-menu"
  }

  return (
    <div className="secondaryNav-page">
      <div className="secondaryNav-container">
        <div className="secondaryNav-headline">校友会</div>
          <div className="secondaryNav-box">
            <div className="secondaryNav-title">校友认证</div>
            <NavLink to="data" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='tongxun' /></div>
              <div className="secondaryNav-name">校友数据</div>
            </NavLink>
            <NavLink to="certification" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='jianli' /></div>
              <div className="secondaryNav-name">认证审核</div>
            </NavLink>
          </div>

          <div className="secondaryNav-box">
            <div className="secondaryNav-title">返校预约</div>
            <NavLink to="revisit_appointment" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='jihua' /></div>
              <div className="secondaryNav-name">预约管理</div>
            </NavLink>
          </div>

          <div className="secondaryNav-box">
            <div className="secondaryNav-title">校友组织</div>
            <NavLink to="organization_categoty" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='renxiangfenlei' /></div>
              <div className="secondaryNav-name">组织分类</div>
            </NavLink>
            <NavLink to="organization" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='jiagou' /></div>
              <div className="secondaryNav-name">组织管理</div>
            </NavLink>
            <NavLink to="organization_join_appointment" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='shoujibiaodan' /></div>
              <div className="secondaryNav-name">加入申请</div>
            </NavLink>
          </div>

          <div className="secondaryNav-box">
            <div className="secondaryNav-title">校友活动</div>
            <NavLink to="event" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='zhishiku' /></div>
              <div className="secondaryNav-name">活动管理</div>
            </NavLink>
            <NavLink to="registration" className={computedClassName}>
              <div className="secondaryNav-icon"><MyIcon name='shoujibiaodan' /></div>
              <div className="secondaryNav-name">报名管理</div>
            </NavLink>
          </div>
      </div>
      <Outlet />
    </div>
  )
}
